import React from 'react';
import { Link } from 'react-router-dom';

function Dashboard() {
  const linkStyle = {
    textDecoration: 'none',
    color: '#333',
    transition: 'all 0.3s ease',
    position: 'relative',
    padding: '2px 4px',
    borderRadius: '3px'
  };

  return (
    <div className="main-content">
      <div className="d-flex align-items-center mb-3">
        <img src="https://www.bps.go.id/_next/image?url=%2Fassets%2Flogo-bps.png&w=96&q=75" alt="Logo BPS" style={{ height: 60, marginRight: 16 }} />
        <div>
          <h3 style={{ color: '#0d47a1', fontWeight: 700, marginBottom: 0 }}>Selamat Datang di Aplikasi e-KGB BPS Mojokerto</h3>
          <div style={{ fontSize: 18, color: '#333' }}>Gunakan menu di samping untuk mengelola data ASN dan KGB secara berkala.</div>
        </div>
      </div>
      <hr />
      <h5 className="mb-3" style={{ color: '#0d47a1', fontWeight: 600 }}>Fitur Utama:</h5>
      <ul style={{ fontSize: 16, marginLeft: 24 }}>
        <li>
          <Link 
            to="/data-asn" 
            style={{ ...linkStyle }}
            className="dashboard-link"
          >
            Manajemen Data ASN
          </Link>
        </li>
        <li>
          <Link 
            to="/data-berkala-pns" 
            style={{ ...linkStyle }}
            className="dashboard-link"
          >
            Data Berkala KGB
          </Link>
        </li>
        <li>
          <Link 
            to="/tabel-gaji-pns" 
            style={{ ...linkStyle }}
            className="dashboard-link"
          >
            Tabel Gaji PNS
          </Link>
        </li>
        <li>Ekspor/Print Data</li>
        <li>Login Aman</li>
      </ul>
      <div style={{ marginTop: 32, color: '#555', fontSize: 15 }}>
        Aplikasi ini dikembangkan untuk memudahkan pengelolaan KGB di lingkungan BPS Mojokerto.
      </div>

      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -100% 0;
            }
            100% {
              background-position: 100% 0;
            }
          }

          .dashboard-link {
            position: relative;
            display: inline-block;
          }

          .dashboard-link:hover {
            color: #0d47a1 !important;
            text-decoration: none !important;
            background: rgba(13, 71, 161, 0.1);
            filter: drop-shadow(0 0 2px rgba(13, 71, 161, 0.3));
          }

          .dashboard-link::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(13, 71, 161, 0.2),
              transparent
            );
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite;
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          .dashboard-link:hover::before {
            opacity: 1;
          }
        `}
      </style>
    </div>
  );
}

export default Dashboard;